import type { SortableGroupColumn } from '@app/application/user-management/types'

import { sortableGroupColumns } from '@app/application/user-management/types'

const SORTABLE_GROUP_COLUMNS: readonly string[] = sortableGroupColumns

export const isSortableGroupColumn = (
  column: string
): column is SortableGroupColumn => SORTABLE_GROUP_COLUMNS.includes(column)
